import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import SelectBox from "../../../components/shared/fields/SelectBox ";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";
import {
  useCreateOvenDataMutation,
  useGetCartListQuery,
  useGetOvensQuery,
  useUpdateOvenDataMutation,
} from "./cookingApi";
import InputWithIcon from "../../../components/shared/fields/InputWithIcon";
import { RefreshSvg } from "../../../svgFiles/RefreshSvg";
import toast from "react-hot-toast";
import { isValidDate, newIncreasingDate } from "../../../components/shared/utils";
import useTranslator from "../../../hooks/useTranslator";
import moment from "moment";
import { convertToUserTimezone, getCurrentDateTime, getTranslatedOvenName } from "../../../helpers/Utils";
import { COOKING_EST_MINUTE_CHEEKS, COOKING_EST_MINUTE_STRIPS } from "../../../helpers/constants";

const CookingModal = ({ show, setShow, record, mode, lot }) => {

  const integerCountFields = [
    "treys_count",
    "cheeks_trey_count",
    "strips_trey_count",
    "tapita_trey_count",
  ];
  const decimalWeightFields = [
    "cheeks_cart_weight",
    "strips_cart_weight",
    "cart_weight",
  ];

  const [createData, { isLoading: isCreating }] = useCreateOvenDataMutation();
  const [updateData, { isLoading: isUpdating }] = useUpdateOvenDataMutation();
  const [status, setStatus] = useState("available");
  const { _t } = useTranslator();

  const initialFormData = {
    status: mode === "add" ? "cooking" : "",
    cheeks_cart_weight: "",
    strips_cart_weight: "",
    treys_count: "",
    cheeks_trey_count: "",
    strips_trey_count: "",
    tapita_trey_count: "",
    time_end: getCurrentDateTime("YYYY-MM-DDTHH:mm"),
    time_entered: getCurrentDateTime("YYYY-MM-DDTHH:mm"),
    type: "",
    cart_number_id: "",
    oven_id: "",
    oven: {},
    cart_number: {},
    data_from: "processing",
    oven_batch_code: lot, //generateOvenBatchId()
  };

  // Dynamic trey count configuration - easy to add/remove types
  const treyCountConfig = {
    "cheeks/strips": [
      { name: "cheeks_trey_count", label: _t("cheeks_trey_count", "Cheeks Trey Count") },
      { name: "strips_trey_count", label: _t("strips_trey_count", "Strips Trey Count") },
    ],
    "cheeks/tapita": [
      { name: "cheeks_trey_count", label: _t("cheeks_trey_count", "Cheeks Trey Count") },
      { name: "tapita_trey_count", label: _t("tapita_trey_count", "Tapita Trey Count") },
    ],
    "cheeks": [
      { name: "cheeks_trey_count", label: _t("cheeks_trey_count", "Cheeks Trey Count") },
    ],
    "strips": [
      { name: "strips_trey_count", label: _t("strips_trey_count", "Strips Trey Count") },
    ],
    "tapita": [
      { name: "tapita_trey_count", label: _t("tapita_trey_count", "Tapita Trey Count") },
    ],
  };

  const [formData, setFormData] = useState(initialFormData);
  const maxEnteredDateTime = getCurrentDateTime("YYYY-MM-DDTHH:mm");
  const [ovenId, setOvenId] = useState(null);

  useEffect(() => {
    if (mode === "edit" && record?.oven?.id) {
      setOvenId(record.oven.id);
    }
  }, [mode, record]);
  const { data: ovenList } = useGetOvensQuery({
    status,
    ...(ovenId ? { oven_id: ovenId } : {}),
  });
  const { data: cartsList, refetch: refetchCartList } = useGetCartListQuery({
    status,
  });
  useEffect(() => {
    if (mode === "edit" && record) {
      setFormData((prevFormData) => {
        const updatedFormData = { ...prevFormData, ...record };

        if (record.oven) updatedFormData.oven_id = record.oven.id;
        if (record.type) updatedFormData.type_id = record.type.id;
        if (record.cart_number)
          updatedFormData.cart_number_id = record.cart_number.id;
        updatedFormData.time_entered = record.time_entered
          ? convertToUserTimezone(record.time_entered,"YYYY-MM-DDTHH:mm")
          : "";
        updatedFormData.time_end = record.time_end
          ? convertToUserTimezone(record.time_end,"YYYY-MM-DDTHH:mm")
          : "";

        return updatedFormData;
      });
    } else if (mode === "add" && show) {
      setFormData({
        ...initialFormData,
        time_entered: getCurrentDateTime("YYYY-MM-DDTHH:mm"),
      });
    }
  }, [mode, record, show]);


  const handleClose = () => {
    setShow(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isCreating || isUpdating) return;

    if (
      formData.time_entered &&
      moment(formData.time_entered).isAfter(moment(maxEnteredDateTime))
    ) {
      toast.error(_t("date_time_cannot_be_future", "Entered date and time cannot be in the future."));
      return;
    }

    // const payload = {
    //   ...formData,
    //   time_entered: formatTime(
    //     formData.time_entered,
    //     true,
    //   ),
    //   time_end: formatTime(
    //     formData.time_end,
    //     true,
    //     true,
    //   ),
    // };

    let payload = { ...formData };

    payload = {
      ...payload,
      ...integerCountFields.reduce((acc, field) => {
        const fieldValue = payload[field];
        acc[field] = fieldValue === "" || fieldValue === undefined || fieldValue === null
          ? 0
          : parseInt(fieldValue, 10) || 0;
        return acc;
      }, {}),
      ...decimalWeightFields.reduce((acc, field) => {
        const fieldValue = payload[field];
        acc[field] = fieldValue === "" || fieldValue === undefined || fieldValue === null
          ? 0
          : parseFloat(fieldValue) || 0;
        return acc;
      }, {}),
    };

    if (payload.date_time_entered) {
      payload = {
        ...payload,
        date_time_entered: moment(formData.date_time_entered).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
      };
    }
    if (payload.time_entered) {
      payload = {
        ...payload,
        time_entered: moment(formData.time_entered).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
      };
    }

    if (payload.time_end) {
      payload = {
        ...payload,
        time_end: moment(formData.time_end).format("YYYY-MM-DD HH:mm:ss"),
      };
    }

    if (payload.oven_batch_code) {
      const value = payload.oven_batch_code;
      const dateRegex = /^(\d{2})(\d{2})(\d{2})$/;

      if (!dateRegex.test(value)) {
        toast.error(_t("invalid_batch_id_format", "Invalid format. Please enter the Batch ID in YYMMDD format."));
        return;
      }
      const year = parseInt(value.substring(4, 6), 10) + 2000;
      const month = value.substring(2, 4);
      const day = value.substring(0, 2);

      if (!isValidDate(year, month, day)) {
        toast.error(_t("invalid_batch_id_date", "Invalid date. Please enter a correct Batch ID."));
        return;
      }
    }
    const mutation = mode === "add" ? createData : updateData;

    try {
      // console.log(payload);
      // return false;
      await mutation(
        mode === "add" ? payload : { id: record.id, requestBody: payload }
      ).unwrap();
      handleClose();
      // Refetch cart list
      refetchCartList();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let increasedMinute = "";
    let expEndTime = "";

    if (integerCountFields.includes(name)) {
      if (value === "") {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: "",
        }));
        return;
      }

      if (!/^\d+$/.test(value)) {
        return;
      }
    }

    // Reset trey count fields when type changes
    if (name === "type") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        cheeks_trey_count: "",
        strips_trey_count: "",
        tapita_trey_count: "",
        treys_count: "",
      }));
    }

    if((name === "time_entered" && formData.type !== "") || name === 'type' ){
      
      let selectedType = formData.type;
      let defaultTime = formData.time_entered;
      
      if(name === "type"){
        selectedType =  value;
        
      }
      
      if(name === "time_entered"){
        defaultTime = value;
      }

      switch(selectedType){
        case "cheeks":
          increasedMinute = COOKING_EST_MINUTE_CHEEKS; // 11:30 Hours
          expEndTime = newIncreasingDate(increasedMinute , defaultTime);
        
          setFormData((prevFormData) => ({
            ...prevFormData,
            ["time_end"]: expEndTime,
          }));

          break;
        case "strips":
          increasedMinute = COOKING_EST_MINUTE_STRIPS; // 9:30 Hours
          expEndTime = newIncreasingDate(increasedMinute , defaultTime);
      
          setFormData((prevFormData) => ({
            ...prevFormData,
            ["time_end"]: expEndTime,
          }));

          break;
        case "cheeks/strips":
          increasedMinute = COOKING_EST_MINUTE_STRIPS; // 9:30 Hours
          expEndTime = newIncreasingDate(increasedMinute , defaultTime);
         
          setFormData((prevFormData) => ({
            ...prevFormData,
            ["time_end"]: expEndTime,
          }));

          break;

        //  ########### Tapita ###########
        case "tapita":
          increasedMinute = COOKING_EST_MINUTE_CHEEKS; // 11:30 Hours
          expEndTime = newIncreasingDate(increasedMinute , defaultTime);
         
          setFormData((prevFormData) => ({
            ...prevFormData,
            ["time_end"]: expEndTime,
          }));

          break;
        // ######### cheeks/tapita ###########
        case "cheeks/tapita":
          increasedMinute = 690; // 11:30 Hours
          expEndTime = newIncreasingDate(increasedMinute , defaultTime);
         
          setFormData((prevFormData) => ({
            ...prevFormData,
            ["time_end"]: expEndTime,
          }));

          break;
      }
    }
    
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const isCartAvailable = (cart) => {
    return cart.status === "available" || cart.id == record?.cart_number.id;
  };

  const renderFormFields = () => (
    <>
    {console.log(ovenList?.data)}
      <Col lg={6}>
        <SelectBox
          label={_t("select_oven", "Select Oven")}
          type="text"
          name="oven_id"
          value={formData.oven_id}
          options={(ovenList?.data || []).map((list) => ({
            value: list.id,
            label: getTranslatedOvenName(list.name , _t),
          }))}
          onChange={handleChange}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("oven_batch_code", "Oven Batch Code")}
          type="text"
          name="oven_batch_code"
          value={formData.oven_batch_code}
          onChange={handleChange}
          disabled={true}          
        />
      </Col>
      
      <Col lg={6}>
        <SelectBox
          label={_t("carts_number", "Carts Number")}
          type="number"
          name="cart_number_id"
          value={formData.cart_number_id}
          options={(cartsList?.data || []).map((list) => ({
            value: list.id,
            label: list.name,
            disabled: !isCartAvailable(list),
          }))}
          onChange={handleChange}         
        />
      </Col>
      <Col lg={6}>
        <SelectBox
          label={_t("type", "Type")}
          type="text"
          name="type"
          value={formData.type}
          options={[
            { value: "cheeks", label: _t("type_cheeks", "Cheeks") },
            { value: "strips", label: _t("type_strips", "Strips") },
            {
              value: "cheeks/strips",
              label: _t("type_cheeks_strips", "Cheeks/Strips"),
            },
            {
              value: "tapita",
              label: _t("type_tapita", "Tapita"),
            },
            {
              value: "cheeks/tapita",
              label: _t("type_cheeks_tapita", "Cheeks/Tapita"),
            },
          ]}
          onChange={handleChange}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("time_entered", "Time Entered")}
          type="datetime-local"
          name="time_entered"
          value={formData.time_entered}
          onChange={handleChange}
          max={maxEnteredDateTime}          
          disabled={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("time_end", "Time End")}
          type="datetime-local"
          name="time_end"
          value={formData.time_end}
          onChange={handleChange}
          // disabled={mode === "edit"}
        />
      </Col>
      
      {/* Dynamic Trey Count Fields based on type */}
      {(mode === "add" || mode === "edit") && treyCountConfig[formData.type] ? (
        treyCountConfig[formData.type].map((field) => (
          <Col lg={6} key={field.name}>
            <InputWithLabel
              label={field.label}
              type="number"
              name={field.name}
              value={formData[field.name]}
              onChange={handleChange}
              placeholder={"0"}
              min={0}
            />
          </Col>
        ))
      ) : (
        <Col lg={6}>
          <InputWithLabel
            label={_t("treys_count", "Treys Count")}
            type="number"
            name="treys_count"
            value={formData.treys_count}
            onChange={handleChange}
            disabled={mode === "edit"}
            placeholder={"0"}
            min={0}
          />
        </Col>
      )}

      <Col lg={6}>
        <SelectBox
          label={_t("status", "Status")}
          type="text"
          name="status"
          value={formData?.status}
          options={
            mode === "add"
              ? [
                  { value: "cooking", label: _t("status_cooking", "Cooking") },
                  {
                    value: "cooling_room",
                    label: _t("status_cooling", "Cooling Room"),
                  },
                ]
              : [
                  {
                    value: "cooking",
                    label: _t("status_cooking", "Cooking"),
                    disabled: true,
                  },
                  {
                    value: "cooling_room",
                    label: _t("status_cooling", "Cooling Room"),
                  },
                  { value: "cart_unloaded", label: _t("cart_unloaded", "Cart Unloaded") },
                ]
          }
          onChange={handleChange}
        />
      </Col>
      {formData.status === "bagged" &&
        (formData.type === "cheeks" ? (
          <Col lg={6}>
            <InputWithIcon
              icon={RefreshSvg}
              label={_t("fruit_weight_cheeks", "Fruit Weight of Cheeks")}
              type="number"
              name="cheeks_cart_weight"
              value={formData.cheeks_cart_weight}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
        ) : formData.type === "strips" ? (
          <Col lg={6}>
            <InputWithIcon
              icon={RefreshSvg}
              label={_t("fruit_weight_strips", "Fruit Weight of Strips")}
              type="number"
              name="strips_cart_weight"
              value={formData.strips_cart_weight}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
        ) : formData.type === "cheeks/strips" ? (
          <Row>
            <Col lg={6}>
              <InputWithIcon
                icon={RefreshSvg}
                label={_t("fruit_weight_cheeks", "Fruit Weight of Cheeks")}
                type="number"
                name="cheeks_cart_weight"
                value={formData.cheeks_cart_weight}
                onChange={handleChange}
                placeholder={"0"}
              />
            </Col>
            <Col lg={6}>
              <InputWithIcon
                icon={RefreshSvg}
                label={_t("fruit_weight_strips", "Fruit Weight of Strips")}
                type="number"
                name="strips_cart_weight"
                value={formData.strips_cart_weight}
                onChange={handleChange}
                placeholder={"0"}
              />
            </Col>
          </Row>
        ) : (
          <Col lg={6}>
            <InputWithIcon
              icon={RefreshSvg}
              label={_t("fruit_weight", "Fruit Weight")}
              type="number"
              name="cart_weight"
              value={formData.cart_weight}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
        ))}
    </>
  );

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "add"
          ? _t("add_title", "Add Oven Data")
          : _t("edit_title", "Move Carts From Cooling Room")
      }
      children={formData}
    >
      <Row>{renderFormFields()}</Row>

      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            disabled={isCreating || isUpdating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default CookingModal;
